module.exports = __webpack_public_path__ + "static/media/cloud_logo.4af063a6.png";